import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

const ClientsReview = () => {
  const reviews = [
    {
      name: "Alex Q.",
      description:
        "My experience with Debt Redemption has been very positive. All the people who have treated me are very professional, knowledgeable, patient and understanding. When I approached the Debt Redemption team I was in a very complicated financial situation. The loss of income had led me to rely on credit cards until I could only make the minimum payments. When talking to the Debt Redemption team, they made me feel great relief knowing that there was a solution to my problem and that with a structured plan, I would get out of debt in a short time. Now I can begin to plan my financial future with greater certainty and increase my retirement savings. I am very grateful to the entire Debt Redemption team.",
      when: "2 years ago",
      showAllText: false,
      gLink: "https://g.page/r/CZgJbjG8pdZSEBM/review",
    },
    {
      name: "Allison Crawfod",
      description:
        "I had see Debt Redemption on the local KEYE new several times but didn't call right away thinking something might change and I could pay my debts paid down. It was just wishful thinking that cost me dearly throwing away over $2500 every month to the credit card payments at with all of my interest rates over 20 percent. Debt Redemption was able to provide me a debt relief program that is less than half of the $2500 I was paying before and it's only going to take 4 years to pay off the debts. I've been in the program a while and they have been settling my debts exactly as they said they would. Even if I could of kept paying the $2500 I don't think I would have ever been able to pay them off without this help. Debt Redemption gets five stars all the way for all of the help they have given me.",
      when: "5 months ago",
      showAllText: false,
      gLink: "https://g.page/r/CcoMERqTmrmvEBM/review",
    },
    {
      name: "George Boyle",
      description:
        "I saw Debt Redemption on the Kens5 news decided to see if they could help me with 72K in credit cards that I have been starting to fall behind in paying. I meet with Jack Brandon at their San Antonio location and what really stood out is he took the time to really get to understand what I was going through with a loss of income and struggling to pay my other bills due to these insanely high interest credit cards. He was able to enroll me in a plan that stopped the horrible harassing creditor calls and is costing me much less than half of what I was having to pay the credit cards.",
      when: "6 months ago",
      showAllText: false,
      gLink: "https://g.page/r/CYcjaVki1keZEBM/review",
    },
    {
      name: "Christina Stapleton",
      description:
        "My family have been struggling. I reached out to them after checking the BBB rating. This company have went above and beyond to explain the process. The extraordinary guidance in managing our debt is wonderful. They have went above and beyond. Our stress has been reduced a thousand percent. Grateful for them. They have been an answer to my prayers. Thank you to the entire team.",
      when: "4 months ago",
      showAllText: false,
      gLink: "https://g.page/r/CcoMERqTmrmvEBM/review",
    },
    {
      name: "Billy Smith",
      description:
        "This is an OUTSTANDING company if you have too much debt. I am half way though the program I signed up for with my debts being reduced by around half of my credit card balances. Compare to other companies their fees are MUCH lower and they were also able to provide some other benefits that other comapnies I contacted before enrolling didn't offer me. Luckly I found Debt Redemption on the Better Businss Buearu website and they have been a complete lifesaver.",
      when: "4 years ago",
      showAllText: false,
      gLink: "https://g.page/r/CbzwS0N4raSJEBM/review",
    },
    {
      name: "Chloe Kaye",
      description:
        "I can say that Debt Redemption may have saved our marriage. My husband and I are coming up on our 10-year anniversary having started off our marriage both having a lot of debt. We manage to pay it down 6 years ago but ended up back in the same boat. We have been trying to pay down the debt so we can start saving for our daughter’s college, but it has been impossible with the high interest rates. Before enrolling with Debt Redemption, we were spending anywhere from $3000 to $3500 just to keep up with the minimum payments. Our marriage has been rocky the past couple years because our family has been financially strapped, and we were both using our credit cards and even taking out additional loans without telling the other. A co-worker told me about Debt Redemption and my husband and I joined the program together. Instead of paying $3,500 a month we have been on a 48-month plan at $1,645 a month so we were able to start saving a lot of money immediately. I don't see how we would have been able to get out of debt otherwise. We knew that because of our income we wouldn’t quality for bankrtypcy and this is exactly what we needed as an alternative and a way out. Doing this bought my husband together as we both dedicated ourselves to getting out our debt and not hiding anything with our finances from each other. We stand to be completely be debt free in about 18 more months, possibly even a little sooner than we expected. This is the best financial decision my husband and I have ever made, and Debt Redemption has been nothing but completely wonderful in helping us get though our debt problems.",
      when: "2 months ago",
      showAllText: false,
      gLink: "https://g.page/r/CZP_cGzTh9vpEBM/review",
    },
  ];

  return (
    <section id="clientsReview" className="bg-custom-lightGray py-16">
      <div className="container">
        <h2 className="text-[40px] text-[#475569] font-semibold text-center mb-6">
          Texans, Helping Texans.
        </h2>
        <Swiper
          pagination={{
            clickable: true,
            el: ".reviews-swiper-pagination",
            renderBullet: function (index, className) {
              return (
                '<span class="!h-2.5 !w-2.5 rounded-full m-2 top-0 right-0 mr-2 bg-custom-gray ' +
                className +
                '"></span>'
              );
            },
          }}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          speed={500}
          modules={[Pagination, Autoplay]}
          slidesPerView={1}
          breakpoints={{
            640: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 1,
            },
            960: {
              slidesPerView: 2,
            },
            1364: {
              slidesPerView: 3,
            },
          }}
          spaceBetween={28}
          loop
        >
          {reviews.map((review, index) => (
            <SwiperSlide className="mb-8" key={index}>
              <div
                className="bg-white rounded-3xl p-6 shadow-lg min-h-[300px]"
                key={index}
              >
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center gap-3">
                    <div className="bg-[#475569] rounded-full w-10 h-10 flex items-center justify-center text-white">
                      {review.name.slice(0, 1)}
                    </div>
                    <div>
                      <h5 className="text-lg text-custom-primary font-semibold">
                        {review.name}
                      </h5>
                      <div className="flex items-center">
                        <img
                          src="/svgs/icons/5-star.svg"
                          key={index}
                          width={98}
                          height={24}
                          alt="Star"
                        />
                        <p className="text-[#475569] text-md font-normal">
                          {review.when}
                        </p>
                      </div>
                    </div>
                  </div>
                  <img
                    src="/images/Google.webp"
                    width={40}
                    height={40}
                    alt="Google"
                  />
                </div>
                <p className="text-md font-medium text-custom-primary leading-6">
                  {review.description.slice(0, 300)}
                  {"... "}
                  <a
                    className="text-custom-primaryLight font-medium"
                    href={review.gLink}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Read More
                  </a>
                </p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="reviews-swiper-pagination flex justify-center" />
      </div>
    </section>
  );
};

export default ClientsReview;
